"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SellerCartItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));
var _lodash = _interopRequireDefault(require("lodash"));
var _ArrowDropDownCircle = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownCircle"));
var _Translations = require("react-platform-components/dist/Translations");
var _SalableItem = require("./SalableItem");
var _config = require("../../config");
var _Link = require("react-platform-components/dist/Link/Link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DefaultReservationDetails;
var RESERVATION_OPTION_UUID;
try {
  DefaultReservationDetails = require('react-platform-reservation/dist/ReservationDetailsOfShoppingCart/ReservationDetails').ReservationDetails;
  RESERVATION_OPTION_UUID = require('react-platform-reservation/dist/configs/index').RESERVATION_OPTION_UUID;
} catch (error) {}
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    container: {
      marginBottom: '2rem',
      paddingBottom: '0.5rem'
    },
    content: {
      padding: '1rem'
    },
    userAvatar: {
      height: 45,
      width: 45
    },
    sellerName: {
      marginLeft: 12
    },
    collapseAreaResume: {
      transformOrigin: '0 0 0'
    },
    collapseBody: {
      width: '100%'
    },
    itemsCount: _defineProperty({
      fontSize: 18,
      marginRight: 20,
      color: '#3a3939'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: 57
    }),
    toggleButton: _defineProperty({}, theme.breakpoints.down('sm'), {
      position: 'absolute',
      marginTop: -47,
      right: 20
    })
  };
});
var SellerCartItems = function SellerCartItems(props) {
  var cartItems = props.cartItems,
    seller = props.seller,
    onDeleteCartItem = props.onDeleteCartItem,
    onUpdateQuantityOfCartItem = props.onUpdateQuantityOfCartItem;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    checked = _React$useState2[0],
    setChecked = _React$useState2[1];
  var classes = useStyles();
  var itemsNumber = (0, _react.useMemo)(function () {
    return _lodash.default.sumBy(cartItems, 'quantity');
  }, [cartItems]);
  var reservationData = (0, _react.useMemo)(function () {
    if (DefaultReservationDetails && cartItems.length === 1) {
      var _cartItems$;
      return _lodash.default.map(_lodash.default.filter((_cartItems$ = cartItems[0]) === null || _cartItems$ === void 0 ? void 0 : _cartItems$.options_linked_to_cart_item, {
        option_uuid: RESERVATION_OPTION_UUID
      }), function (reservationLinkedOption) {
        return reservationLinkedOption.extra_data;
      });
    }
    return null;
  }, [cartItems]);
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 1,
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between"
  }, seller && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 6,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.userAvatar
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.sellerName
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Vendeur",
    defaultMessage: "Vendeur"
  }), ":\xA0", _lodash.default.has(seller, 'store') ? /*#__PURE__*/_react.default.createElement(_Link.Link, {
    base: _config.BASE_URL,
    to: "".concat(_config.SELLER_PAGE, "/").concat(seller.store.id),
    target: "_blank",
    rel: "noopener noreferrer"
  }, seller.store.name) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
    base: _config.BASE_URL,
    to: "".concat(_config.SELLER_PAGE, "/").concat(seller.id),
    target: "_blank",
    rel: "noopener noreferrer"
  }, _config.SELLER_NAME_DISPLAY === "NP" ? seller.name : _config.SELLER_NAME_DISPLAY === "N" ? seller.name.split(" ")[0] : seller.name.split(" ")[1])))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_Grow.default, _extends({
    in: checked,
    className: classes.collapseAreaResume
  }, checked ? {
    timeout: 2000
  } : {}), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: classes.itemsCount
  }, itemsNumber, " ", itemsNumber > 1 ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "items",
    defaultMessage: "items"
  }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "item",
    defaultMessage: "item"
  })))), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "default",
    className: classes.toggleButton,
    "aria-label": "add to shopping cart",
    onClick: function onClick() {
      return setChecked(!checked);
    }
  }, /*#__PURE__*/_react.default.createElement(_ArrowDropDownCircle.default, checked ? {
    style: {
      transform: 'rotate(180deg)',
      transition: 'transform 0.3s ease-in-out'
    }
  } : {
    style: {
      transform: 'rotate(0deg)',
      transition: 'transform 0.3s ease-in-out'
    }
  })))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: !checked,
    className: classes.collapseBody
  }, _lodash.default.map(cartItems, function (cartItem) {
    return /*#__PURE__*/_react.default.createElement(_SalableItem.SalableItem, {
      key: cartItem.id,
      cartItem: cartItem,
      onUpdateQuantity: function onUpdateQuantity(value) {
        return onUpdateQuantityOfCartItem(cartItem.id, value);
      },
      onDelete: function onDelete() {
        return onDeleteCartItem(cartItem.id);
      }
    });
  }), /*#__PURE__*/_react.default.createElement("br", null), !_lodash.default.isEmpty(reservationData) && /*#__PURE__*/_react.default.createElement(DefaultReservationDetails, {
    reservationData: reservationData,
    cartItems: cartItems[0]
  }))));
};
exports.SellerCartItems = SellerCartItems;